import { Component, OnInit, ViewChild } from '@angular/core';
import { DetailPaymentService } from './services/detail.payment.service';
import { ImageService } from '../../core/services/image.service';
import { PaymentsService } from '../../core/services/payments.service';
import { PaymentIconsService } from 'src/app/core/services/payment-icons.service';
import { AppIcon } from 'src/app/shared/interfaces/app-icon';
import { MatDialogRef } from '@angular/material/dialog';
import { IdentityService } from 'src/app/core/services/identity.service';
import { DialogAfipComponent } from 'src/app/shared/components/dialog-afip/dialog-afip.component';
import { PaymentModel } from 'src/app/core/models/payment.model';
import { RefundPaymentService } from 'src/app/core/services/refund-payment.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { environment } from 'src/environments/environment';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';
import { runtimeEnv } from 'src/environments/env-loader';

@Component({
  selector: 'app-detail-pay',
  templateUrl: './detail-pay.component.html',
  styleUrls: ['./detail-pay.component.scss']
})
export class DetailPayComponent implements OnInit {
  @ViewChild('nombre') nombre: HTMLDivElement;

  data: PaymentModel;
  refundForm: UntypedFormGroup;
  titulo: any;
  receiverImage = '/assets/images/Avatar.png';
  showImage = false;
  flipped = false;
  refund = false;
  flipCard: boolean;
  isFlipped: boolean = false;
  showMore: boolean = false;
  isCommerce: boolean;
  refundLoading: boolean = false;
  billeteras = {
    'com.yacare.test': 'Yacaré',
    'ar.com.santander': 'Santander Río',
    'com.mercadolibre': 'Mercado Pago',
    'ar.com.bna': 'BNA+',
    'com.columbia': 'Columbia',
    'ar.com.cuentadni': 'Cuenta DNI',
    'app.ank': 'Ank',
    'ar.com.reba': 'Reba',
    'ar.com.modo': 'MODO',
    'ar.com.claro': 'Claro',
    'ar.com.moni': 'Moni',
    'app.miiii': 'Miiii',
    'ar.com.epagos': 'E Pagos',
    'ar.com.uala': 'Ualá',
    'com.resimple': 'Re Simple',
    'ar.com.valepei': 'Vale Pei',
    'com.pluspagos': 'Plus Pagos',
    'com.auntap': 'Tap',
    'ar.com.personalpay': 'Personal Pay'
  };

  pspDemo = {
    '0300': 'AgilPagos',
    '0009': 'Mercado Pago',
    '0406': 'E Pagos',
    '0028': 'Ualá',
    '0070': 'Re Simple',
    '0170': 'Tap',
    '0314': 'Personal Pay',
    '0247': 'Claro',
    '0254': 'Plus Pagos'
  };

  pspProd = {
    '0003': 'Mercado Pago',
    '0010': 'Miiii',
    '0029': 'Nubi',
    '0034': 'Re Simple',
    '0040': 'Tap',
    '0072': 'MONI',
    '0091': 'Taca Taca',
    '0119': 'viüMi',
    '0130': 'E Pagos',
    '0148': 'Openpay'
  };
  appEnvironment: string;
  downloadLoading = false;

  constructor(
    private detailPayment: DetailPaymentService,
    private imageService: ImageService,
    private paymentsService: PaymentsService,
    private paymentIconService: PaymentIconsService,
    private matDialog: MatDialogRef<DialogAfipComponent>,
    private refundPaymentService: RefundPaymentService,
    private formBuilder: UntypedFormBuilder,
    private identity: IdentityService,
    private router: Router,
    private dialog: MatDialog,
    private nativeBridgeService: NativeBridgeService
  ) {}

  ngOnInit() {
    this.appEnvironment = this.nativeBridgeService.getEnvironment();
    if (!this.detailPayment.storage) {
      this.goBack();
    }
    this.data = this.detailPayment.storage;

    if (this.identity.isCommerce()) {
      this.isCommerce = true;
    }

    this.refundForm = this.formBuilder.group({
      reason: new UntypedFormControl(null, { updateOn: 'blur', validators: [Validators.required] })
    });
    if ((this.showImage = this.data.titulo.startsWith('<'))) {
      this.showImage = true;
    }

    this.titulo = (<string>this.data.titulo).replace('img-placeholder', '');

    this.imageService.requestProfileImage(this.data.imgId).then((img) => (this.receiverImage = img));
  }

  navigate(url: string) {
    this.router.navigate([url]);
    this.matDialog.close({});
  }

  setClassEstado(estado) {
    if (estado == 'Confirmado') return 'confirmado';
    else if (estado == 'Acreditado') return 'acreditado';
    else if (estado == 'Aprobado') return 'confirmado';
    else if (estado == 'Pendiente') return 'pendiente';
    else if (estado == 'Anulado') return 'anulado';
    else return 'error';
  }

  goBack() {
    this.matDialog.close({});
  }

  isDemo() {
    return runtimeEnv.APIURL == 'https://services.latam-yacare-core-nonprod.aws.fisv.cloud/qr-latam-core/api'
      ? true
      : false;
  }

  isPSP(billetera): boolean {
    if (billetera !== null) {
      return billetera.length == 4 ? true : false;
    }
    return false;
  }

  generarTitulo(element, billetera?) {
    let wallet = '';
    if (element == 'Transferencia 3.0') {
      if (this.isPSP(billetera) && this.isDemo()) {
        wallet = this.pspDemo[billetera];
      } else if (this.isPSP(billetera) && !this.isDemo()) {
        wallet = this.pspProd[billetera];
      } else if (!this.isPSP(billetera)) {
        wallet = this.billeteras[billetera];
      }

      if (wallet == '') {
        wallet = 'Desconocido';
      }
    } else if (element !== 'Transferencia 3.0') {
      wallet = element;
    }

    return wallet;
  }

  evaluarEstadoMov(estado: any) {
    switch (estado) {
      case estadoMovimiento.ANULADO:
        return false;
      case estadoMovimiento.APROBADO:
        return true;
      case estadoMovimiento.ACREDITADO:
        return true;
      case estadoMovimiento.CONFIRMADO:
        return true;
    }
  }

  evaluarMovimiento(data: any) {
    switch (data.tipoMovimiento) {
      case tipoMovimiento.SALIENTE:
        return false;
      case tipoMovimiento.ENTRANTE:
        return true;
    }
  }

  evaluarTitulo(titulo: string) {
    if (
      titulo.startsWith('<span class="sa-center">Ret.') ||
      titulo.startsWith('<span class="sa-center">Comisión') ||
      titulo.startsWith('<span class="sa-center">Devolución') ||
      titulo.startsWith('<span class="sa-center">Depósito')
    ) {
      return false;
    }
    return true;
  }

  maskCuit(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(2, 10);
    let end = cuit.substring(10, 11);
    return `${first}-${dni}-${end}`;
  }

  refundTimeOut() {
    this.showMore = !this.showMore;
    setTimeout(() => {
      this.refund = !this.refund;
    }, 300);
  }

  maskPrice(price: string) {
    if (price.startsWith('-')) {
      let importe = price.slice(1);
      return `-$${importe}`;
    } else {
      return `$${price}`;
    }
  }

  getReason() {
    this.refundForm.controls['reason'].value;
  }

  async refundPaymentSubmit(data: any) {
    this.refundLoading = true;
    let result = await this.refundPaymentService.refusePayment(data);
    if (result) {
      this.matDialog.close({ refresh: true });
    }
    this.refundLoading = false;
  }

  getIcon(icon: string, billetera?: string): AppIcon {
    return this.paymentIconService.getIcon(icon, billetera);
  }

  download() {
    if (this.data.comprobanteDisponible) {
      this.downloadLoading = true;
      this.paymentsService
        .downloadTicket(this.data.id)
        .then((_res) => {
          this.downloadLoading = false;
        })
        .catch(() => {
          this.downloadLoading = false;
        });
    }
  }

  get monto() {
    return this.data.monto
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&.')
      .replace(/.([^.]*)$/, ',$1');
  }
  get saldo() {
    return this.data.balanceCuenta
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&.')
      .replace(/.([^.]*)$/, ',$1');
  }

  async openDialog(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: 1,
        title: '¿Quieres continuar?',
        info: 'Estás a punto de anular un pago'
      };

      const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
          this.refundPaymentSubmit({
            paymentId: this.data.id,
            reason: 'refund'
          });
        }
      });
    });
  }
}

enum tipoMovimiento {
  SALIENTE = 'OutboundTransaction',
  ENTRANTE = 'IncomingTransaction'
}

enum estadoMovimiento {
  ANULADO = 'Anulado',
  CONFIRMADO = 'Confirmado',
  APROBADO = 'Aprobado',
  ACREDITADO = 'Acreditado'
}
